<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label">
  <div app-theme-option-content>
    <button *ngFor="let value of values" mdbBtn (click)="onValue(value)" type="button" color="light" size="sm" class="px-2 z-depth-0 my-0 ml-1 mr-0" mdbWavesEffect>
      <i class="fas fa-align-{{value}} fa-fw {{ value == themeOptions.options().tooltips['titleAlign'] ? color : 'blue-grey' }}-text"></i>
    </button>
  </div>
</app-theme-option>